<template>
  <div class="wrapper">
    <div>
      <button
        type="button"
        class="positive"
        :class="{ selected: value === 'positive' }"
        :disabled="disabled"
        @click="() => click('positive')"
      >
        <span>
          <font-awesome-icon icon="check"/>
        </span>
        {{ $t('orderList.finalOpinion.positive') }}
      </button>
      <button
        type="button"
        class="negative"
        :class="{ selected: value === 'negative' }"
        :disabled="disabled"
        @click="() => click('negative')"
      >
        <span>
          <font-awesome-icon icon="xmark"/>
        </span>
        {{ $t('orderList.finalOpinion.negative') }}
      </button>
    </div>
    <p>{{ error }}</p>
  </div>
</template>

<style scoped>
  .wrapper {
    margin-bottom: 20px;
    text-align: center;
  }

  .wrapper > div > button {
    margin: 20px;
    padding: 0;
    font-size: 3rem;
    font-weight: 600;
    background-color: transparent;
    border: none;
    opacity: 0.3;
    cursor: pointer;
    transition-property: opacity;
    transition-duration: 0.2s;
  }

  .wrapper > div > button.positive {
    color: #35c589;
  }

  .wrapper > div > button.negative {
    color: var(--error-color);
  }

  .wrapper > div > button:disabled {
    cursor: default;
  }

  .wrapper > div > button.selected {
    opacity: 1;
  }

  .wrapper > div > button > span {
    margin-right: 10px;
    opacity: 0;
    transition-property: opacity;
    transition-duration: 0.2s;
  }

  .wrapper > div > button.selected > span {
    margin-right: 10px;
    opacity: 1;
  }
</style>

<script>
  export default {
    props: [
      'disabled',
      'value',
      'click',
      'error'
    ]
  }
</script>
